const cancellationHtml = String.raw`<p>אתר האינטרנט של רב-מילים מופעל על ידי חברת מלינגו בע"מ, ח.פ. 513059667 (להלן: "<strong>האתר</strong>"/"<strong>אתר רב-מילים</strong>" ו"<strong>רב-מילים</strong>" בהתאמה).</p>

<p>מי שרכש מינוי באתר רב-מילים (להלן: "<strong>הלקוח</strong>") רשאי לבטל את המינוי בהתאם להוראות חוק הגנת הצרכן, תשמ"א-1981 (להלן: "<strong>החוק</strong>") ותקנותיו.</p>

<p>לתשומת ליבכם, עסקה לרכישת מינוי המתבצעת דרך האתר מוגדרת כעסקת מכר מרחוק לפי סעיף 14ג לחוק.</p>

<p>מבלי לגרוע מהאמור לעיל, תפורט להלן מדיניות רב-מילים ביחס לביטול עסקה לרכישת מינוי:</p>

<ol>

<li>הלקוח רשאי לבטל מינוי שרכש באתר בתוך 14 ימים ממועד ביצוע העסקה באמצעות מסירת הודעת ביטול (כמפורט בסעיף 4 להלן). בביטול כאמור יוחזר ללקוח הסכום ששולם עבור רכישת המינוי.</li>

<li>במקרה של מינוי חודשי ששולם בגינו מחיר מלא (ללא הנחה מסוג כלשהו או שימוש בקופון), יחולו ההוראות הבאות: הלקוח יהיה רשאי לבטל את המינוי באמצעות מסירת הודעת ביטול לרב-מילים (כמפורט בסעיף 4 להלן), והמינוי יבוטל בתוך שלושה ימי עסקים מיום שנמסרה הודעת הביטול, ואם נמסרה הודעת הביטול באמצעות דואר רשום, אזי המינוי יבוטל בתוך שישה ימי עסקים מיום מסירתה למשלוח, והכל אם לא נקב הלקוח במועד מאוחר יותר בו יש לבטל את המינוי (להלן: "<strong>מועד הביטול</strong>"). בביטול כאמור, יוחזר ללקוח הסכום ששולם עבור אותו החודש, בניכוי החלק היחסי במינוי שבו נעשה שימוש (או ניתן היה לעשות בו שימוש) עד למועד הביטול.</li>

<li>למעט האמור בסעיפים 1-2 לעיל, לא ניתן יהיה להפסיק ו/או לבטל מינוי במהלך תקופת המינוי והלקוח יחויב במלוא מחיר המינוי (החודשי או השנתי) עד תום תקופת המינוי, אף אם הפסיק להשתמש במינוי. במידה שהלקוח אינו מעוניין כי בתום תקופת המינוי המינוי יחודש באופן אוטומטי לתקופה העוקבת, עליו למסור הודעת ביטול לרב-מילים טרם תחילת מחזור החיוב הבא.</li>

<li>ניתן למסור לרב-מילים הודעה על ביטול עסקה (לעיל ולהלן: "<strong>הודעת ביטול</strong>") בכל אחד מן האמצעים הבאים:

<ul>

<li>בעל פה במספר הטלפון: 03-6070927 (בשעות הפעילות בלבד), תוך מסירת שם מלא, פרטים מזהים של המינוי (כגון שם משתמש/דוא"ל) ופרטים ליצירת קשר.</li>

<li>בהודעה בכתב בדואר רשום לכתובת תוצרת הארץ 16, תל אביב עבור הנמען <strong>מלינגו בע"מ</strong> או בדוא"ל: websupport@melingo.com. יש לכלול בפניה את כל הפרטים הבאים: שם מלא, מספר תעודת זהות, ופרטים ליצירת קשר של בעל המינוי.</li>

<li>באמצעות לחיצה על קישור ייעודי לביטול עסקה המופיע בדף הראשי של האתר.</li>

</ul>

</li>

<li>החזרים כספיים יעשו באותו האופן שבו בוצע התשלום בגין העסקה, בתוך 7 ימי עסקים ממועד ביטול העסקה ובכפוף לעמידה בכל התנאים לביטול עסקה.</li>

<li>במקרה של שימוש בתווי קניה, שובר מתנה או כרטיס מגנטי נטען, לא ינתן החזר כספי.</li>

<li>עסקת מכר מרחוק שנעשתה על ידי אדם עם מוגבלות, אזרח ותיק או עולה חדש, ניתנת לביטול בתוך 4 חודשים מיום ביצוע העסקה, בכפוף לכך שההתקשרות בעסקה כללה שיחה בין הלקוח לבין נציג רב-מילים (לרבות באמצעות תקשורת אלקטרונית) ובהצגת מסמך המעיד על כך שהלקוח הוא אדם עם מוגבלות, אזרח ותיק או עולה חדש, לפי העניין. בביטול כאמור, יוחזר ללקוח הסכום ששולם עבור רכישת המינוי, בניכוי דמי ביטול בסך של 100 ש"ח או 5% ממחיר המינוי (הנמוך מביניהם), ובנוסף ינוכה החלק היחסי במינוי שבו נעשה שימוש (או ניתן היה לעשות בו שימוש) עד להודעת הביטול.</li>

<li><u>ביטול עסקה על ידי רב-מילים</u>: רב-מילים תהיה רשאית לבטל עסקה לרכישת מינוי (כולה או חלקה) בכל אחד מהמקרים הבאים, בהתאם לשיקול דעתה הבלעדי והמוחלט:

<ul>

<li>במקרה של טעות ו/או תקלה ו/או שיבוש במחיר המינוי ו/או בתיאורו.</li>

<li>במקרה שלא שולם סכום המינוי ו/או חלק ממנו.</li>

<li>במקרה של כוח עליון, פעולות מלחמה, איבה, טרור, מגפות, סגרים או מגבלות מצד הרשויות, או כל מקרה אחר שיש בו למנוע את פעילות האתר ו/או להכביד עליה.</li>

<li>במקרה של הפרת הדין ו/או הוראות תנאי השימוש.</li>

<li>במקרה של ניצול לרעה ו/או שימוש לרעה באתר ו/או בתוכן האתר ו/או במינוי.</li>

</ul>

</li>

</ol>



<p><strong><u>שונות</u></strong><strong>:</strong></p>

<ol start="9">

<li>לבקשות ו/או שאלות ו/או הצעות שיפור בנושאי נגישות, אנא פנו אלינו בצירוף פרטים מלאים לדוא"ל websupport@melingo.com.</li>

<li>כל התנהגות של רב-מילים ו/או מי מטעמה לטובת הלקוח בניגוד לאמור לעיל, תהא לפנים משורת הדין בלבד ולא תחשב כויתור של רב-מילים על האמור לעיל.</li>

<li>במקרה של סתירה ו/או אי-התאמה בין הוראות כללים אלה לבין פרסומים אחרים של רב-מילים, תגברנה הוראות כללים אלה.</li>

<li>הדין החל על כללים אלה, פירושם, תוקפם, תחולתם ואכיפתם הוא דין מדינת ישראל בלבד. סמכות השיפוט הבלעדית בקשר עם כללים אלה מוקנית לבית המשפט המוסמך בעיר תל אביב יפו.</li>

</ol>

<p class=MsoNormal dir=LTR><span>&nbsp;</span></p>

<p class=MsoNormal dir=RTL><span lang=HE>&nbsp;</span></p>
`;

export default cancellationHtml;
